var PlaylistHeader           = require("./PlaylistHeader"),
    PlaylistItem             = require("./PlaylistItem"),
    RepeaterArrayDataAdapter = require("enyo-ui/RepeaterArrayDataAdapter"),
    SimpleRepeater           = require("enyo-ui/SimpleRepeater"),
    frameThrottle            = require("enyo-perf/utils").frameThrottle,
    get                      = require("object-path").get,
    kind                     = require("enyo/kind");

require("./Playlist.less");

module.exports = kind(/** @lends app.PlaylistPage.Playlist.prototype */ {

    /**
     * @private
     */
    name: "app.PlaylistPage.Playlist",

    /**
     * @private
     */
    classes: "app-playlist-page-playlist",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:            "playlist",
        kind:            SimpleRepeater,
        classes:         "app-playlist-page-playlist__playlist",
        tag:             "table",
        dataAdapterKind: RepeaterArrayDataAdapter,

        /**
         * @param  {Object}  record  The record to be shown
         * @returns  {enyo.Control}  The control kind
         */
        getChildKind: function(record) {
            switch (record.type) {
                case "header":
                    return PlaylistHeader;
                default:
                    return PlaylistItem;
            }
        }
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state         = this.state || {},
            playlistItems = get(state, "data.category_content", []),
            $playlist     = this.$.playlist;

        if (playlistItems.length > 0) {
            $playlist.set("data", [{
                type: "header"
            }].concat(playlistItems));
        }
        else {
            $playlist.set("data", []);
        }
    }
});
